/*
  preorder-consent.js
  ------------------------------------------------------------------
  受注生産・予約商品の同意チェック（2026-09 施策⑥）。snippets/preorder-consent.liquid とセット。

  - チェックの ON/OFF で、同じフォーム内の決済ボタン（data-preorder-consent-lock 付き）を押せる/押せないに切り替える
  - ミニカートは Ajax で中身が丸ごと差し替わる（theme.js が innerHTML を置き換える）ため、
    イベントは document への委譲で拾う。差し替え後は Liquid が「未チェック・押せない」で出し直すので状態は揃う
  - 期間外商品ガード（cart-period-guard.js）が button--disabled を付けたボタンは、チェックしても押せるようにしない
  - GA4: preorder_consent_view（表示）/ preorder_consent_check（チェックON）。計測の失敗で機能は止めない
*/
(function () {
  'use strict';

  var ROOT = '[data-preorder-consent]';
  var CHECKBOX = '[data-preorder-consent-checkbox]';
  var LOCKED_BUTTON = 'button[name="checkout"][data-preorder-consent-lock]';

  function track(name, root) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        consent_context: (root && root.getAttribute('data-context')) || 'unknown',
        preorder_items: Number((root && root.getAttribute('data-count')) || 0)
      });
    } catch (e) { /* 計測失敗は無視 */ }
  }

  function sync(checkbox) {
    var form = checkbox.form || checkbox.closest('form');
    if (!form) return;
    var root = checkbox.closest(ROOT);
    var hint = root && root.querySelector('[data-preorder-consent-hint]');

    form.querySelectorAll(LOCKED_BUTTON).forEach(function (btn) {
      // 期間外商品ガードで止めたボタンは触らない
      if (btn.classList.contains('button--disabled')) return;
      btn.disabled = !checkbox.checked;
    });
    if (root) {
      root.classList.toggle('is-checked', checkbox.checked);
      if (checkbox.checked) root.classList.remove('is-attention');
    }
    if (hint) hint.hidden = checkbox.checked;
  }

  document.addEventListener('change', function (event) {
    var cb = event.target;
    if (!cb || !cb.matches || !cb.matches(CHECKBOX)) return;
    sync(cb);
    if (cb.checked) track('preorder_consent_check', cb.closest(ROOT));
  });

  // 未チェックのまま押せないボタンの周りを押したら、同意欄へ目を向けさせる
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    // 押せないボタンは CSS で pointer-events:none にしてあり、クリックは外側の枠に届く。他のリンク・ボタンは対象外
    if (t.closest('a, button:not([disabled])')) return;
    var wrap =t.closest('.mini-cart__button-container, .cart-recap__checkout-wrap');
    if (!wrap) return;
    var form = wrap.closest('form');
    var root = form && form.querySelector(ROOT);
    var cb = root && root.querySelector(CHECKBOX);
    if (!cb || cb.checked) return;
    var btn = form.querySelector(LOCKED_BUTTON);
    if (!btn || !btn.disabled || btn.classList.contains('button--disabled')) return;
    root.classList.remove('is-attention');
    void root.offsetWidth; // アニメーションを再実行させる
    root.classList.add('is-attention');
  });

  // 表示計測: 同意欄が実際に見えたとき1回だけ（ミニカートは開くたび・差し替えのたびに新しい要素になる）
  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function scan() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      var cb = root.querySelector(CHECKBOX);
      if (cb) sync(cb); // ブラウザが戻る操作でチェック状態を復元した場合にボタンを揃える
      if (!seen || seen.has(root) || root.offsetParent === null) return;
      seen.add(root);
      track('preorder_consent_view', root);
    });
  }

  function init() {
    scan();
    var mini = document.getElementById('mini-cart');
    if (mini && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { setTimeout(scan, 50); })
        .observe(mini, { childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
